// @flow
import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import { INIT_MENU, CHANGE_ACTIVE_MENU_FROM_LOCATION } from './constants';
import assignIds from './utils';
import { initMenuSuccess, changeActiveMenuFromLocationSuccess } from './actions';
import masterApi from './../../Api/masterApi';
import { isUserAuthenticated } from './../../helpers/authUtils';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';

/**
 * Activate menu items from location
 * @param {*} menuItems
 */
const getActivatedMenuItemIds = menuItems => {
    let matchingItems = [];
    for (let menuItem of menuItems) {
        if (window.location.pathname.indexOf(menuItem.path) === 0) {
            matchingItems.push(menuItem.id);
        }

        if (typeof menuItem.children !== 'undefined') {
            matchingItems = [...matchingItems, ...getActivatedMenuItemIds(menuItem.children)];
        }
    }
    return matchingItems;
};

/**
 * Initilizes the menu
 */
function* initMenuAndItems() {
    try {             
        let d= yield call(masterApi.cp_menus)  
            let data=yield d.json()
            let parents=data.data.filter(l=>l.parent=="")
            parents.map(l=>{
            l.children=data.data.filter(m=>m.parent==l.path).map(n=>{
            //n.component=Pages({component:n.component})
            //n.icon=null
            //n.route=PrivateRoute
            //n.roles=n.roles?n.roles.split(','):[]
            return n
            })
            })
       // console.log(parents)

        const menuItems = assignIds(parents);
        yield put(initMenuSuccess(menuItems));
    } catch (error) {}
}


/**
 * change the active menu item based on location
 */
function* changeActiveMenuFromLocation() {
    try {   
        let project = yield select((state) => state.AppMenu);        
        const menuItems = assignIds(project.menuItems?project.menuItems:[]);
        const activatedMenuItemIds = yield call(getActivatedMenuItemIds, menuItems);
        yield put(changeActiveMenuFromLocationSuccess(activatedMenuItemIds));
    } catch (error) {}
}

/**
 * Watchers
 */
export function* watchMenuInit() {
    yield takeEvery(INIT_MENU, initMenuAndItems);
}

export function* watchMenuChange() {
    yield takeEvery(CHANGE_ACTIVE_MENU_FROM_LOCATION, changeActiveMenuFromLocation);
}

function* appMenuSaga() {
    yield all([fork(watchMenuInit), fork(watchMenuChange)]);
}


const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            if (!isUserAuthenticated()) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: '/account/login', state: { from: props.location } }} />;
            }  
            return <Component {...props} />;
        }}
    />
);

export default appMenuSaga;
